import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {ConfirmCancel} from "../common/confirm-cancel";
import {WizardControl} from "../common/wizard-control";

import {BuildingSelector}    from "./common/building-selector";
import {Step1SelectBuilding} from "./step-1-select-building/step-1-select-building";
import {Step2EditLists}      from "./step-2-edit-lists/step-2-edit-lists";
import {Step3ListName}       from "./step-3-list-name/step-3-list-name";
import { Step4CassResult }   from "./step-4-cass-result/step-4-cass-result";

export const Decondo = ({next, onClose, onCreated, entityId, onCancel, cancelLabel="Cancel"}) => cs(
    consumeContext("apis"),
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ["buildingSelector", (_, next) => BuildingSelector({next})],
    ["step1", ({buildingSelector}, next) => Step1SelectBuilding({buildingSelector, next})],
    ["step2", ({buildingSelector}, next) => Step2EditLists({buildingSelector, next})],
    ["step3", (_, next) => Step3ListName({entityId, next})],
    ["step4", (_, next) => Step4CassResult({entityId, next})],
    ["wizardControl", ({step1, step2, step3, step4}, next) => WizardControl({
        steps: [
            {
                render: () => (
                    step1.render({
                        onNext: async (building) => {
                            await step2.addBuilding(building);
                        },
                        onCancel,
                        cancelLabel,
                    })
                ),
            },
            {
                condition: () => step2.ready,
                render: () => (
                    step2.render({
                        onNext: (a) => {
                            step3.accept(a);
                        },
                    })
                ),
            },
            {
                condition: () => step3.ready,
                render: () => (
                    step3.render({
                        onNext: (mlId, listName) => {
                            step4.acceptMailingListId(mlId);
                            step4.acceptListName(listName);
                        },
                    })
                ),
            },
            {
                condition: () => step4.ready,
                render: () => (
                    step4.render({
                        onClose: (mlId) => {
                            onCreated([mlId]);
                            onClose();
                        },
                    })
                ),
            },
        ],
        next,
    })],
    ({confirmCancel, wizardControl}) => (
        next({
            onPassiveClose: confirmCancel,
            content: cs(
                keyed(wizardControl.currentStep.index),
                () => wizardControl.currentStep.render(),
            ),
        })
    )
);
